/* eslint-disable camelcase, @typescript-eslint/no-explicit-any */

import type { SegmentTrackMainNavMenuClickEvent } from "@beautypie/segment/Track/MainNavMenuClick";
import type { User } from "lib/apollo/types";

declare global {
  interface Window {
    dataLayer: any[];
    // eslint-disable-next-line camelcase
    google_tag_manager: any;
    OnetrustActiveGroups: string;
    OneTrust: any;
  }
}

export enum DataLayerEvent {
  ProductClick = "productClick",
  ProductImpression = "productImpression",
  ProductView = "productView",
  AddToBasket = "addToBasket",
  TrackCheckoutProducts = "checkout",
  TrackPurchaseProducts = "purchase",
  RemoveFromBasket = "EEOrderRemoveFromCart",
  ViewBasket = "checkout",
  PageView = "page_view",
  PushToDataLayer = "pushToDataLayer",
  Login = "Login",
  Logout = "Logout",
  Search = "SiteSearch",
  Click = "Click",
  Set = "Set",
  VideoTracking = "Video Tracking",
  AddToWishlist = "Add to Wishlist",
  JoinPageClick = "joinpageClick",
  JoinPageElementView = "joinpageElementView",
  RemoveFromWishlist = "Remove From Wishlist",
  ProductImageViewed = "Product Image Viewed",
  ProductDescriptionViewed = "Product Description Viewed",
  ProductReviewViewed = "Review Viewed",
  ProductShared = "shareProduct",
  MembershipExtended = "membershipExtended",
  MembershipCancelled = "membershipCancelled"
}

export enum DataLayerMembershipStatus {
  Inactive = "Inactive",
  Active = "Active"
}

export type DimensionKey = keyof DataLayer;
export type DimensionValue = string | number | undefined;
export type DimensionReducer = (...args: any[]) => DimensionValue;

/**
 * The following DataLayer dimensions are specified as variables in GTM,
 * and pertain to the current (old) store front, and therefore cannot be changed (yet)
 */
export type DataLayer = {
  store: string;
  member_id: string;
  membership_status: DataLayerMembershipStatus;
  membership_level: string;
  email_address: string;
  date_of_birth: string;
  MembershipEndDate: string;
  MembershipStartDate: string;
  RegistrationDate: string;
  TotalOrders: number;
  internalExperimentValue: string;
  internalExperimentName: string;
  category: string | undefined;
  subCategory: string | undefined;
  subSubCategory: string | undefined;
  order_basket_type: string;
  hotjar_membership_term: string;
  average_order_value: string;
  hashed_email_address: string;
  originalLocation: string;
  pageType: string;
  postalCode: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
};

export type PII = {
  postalCode?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
};

export type GTMEvent = {
  name: DataLayerEvent;
  data?: Record<string, unknown>;
  locale?: string;
  url?: string;
  pathname?: string;
  referrer?: string;
  dataLayer?: {
    dimension: DimensionKey;
    value: DimensionValue;
  };
  basketItems?: Record<string, string>[];
  user?: User;
  is404?: boolean;
  eventId?: string;
};

export type ClickValueType =
  | SegmentTrackMainNavMenuClickEvent["properties"]["menu_category"]
  | "Search Menu Item Clicked";

export type ClickType = {
  event: string;
  event_id: string;
  value: string;
  label?: ClickValueType;
  clickText?: string;
  clickUrl?: string;
};

export type LocationType =
  | "Sticky Footer"
  | "None"
  | "L&G Hero Banner"
  | "L&G How to Redeem"
  | "Banner"
  | "Breakout area";
